import init from '../../helpers/init';
import {showAlert} from '../main';

const {$} = init;
const BX = (<any>window).BX;

$(() => {
  let mainModalClass = '.js-load-modal-main';
  // загружает компонент в попап
  $(document).on('mousedown', '.js-load-modal', function(){
    let element = $(this);
    if(element.attr('data-bs-target') && element.attr('href')){
      let popupTarget = element.attr('data-bs-target');
      if($('.modal' + mainModalClass + popupTarget).length){
        $('.modal'+ mainModalClass + popupTarget + ' .js-modal-body').html('Loading...');
        $.ajax({
          method: 'GET',
          url: element.attr('href'),
          dataType: 'html'
        }).done(function (data) {
          $('.modal' + popupTarget + ' .js-modal-body').html(data);
        }).fail(function () {
          showAlert(BX.message('LANGUAGE_ID') === 'en' ? 'Error! If you are using AdBlock or any other blocker, please disable it.' : 'Ошибка! Если вы используете AdBlock или любой другой блокировщик - отключите его, пожалуйста.');
        });
      }
    }
  });

  // очищает попап при закрытии
  $('.modal'+ mainModalClass).on('hide.bs.modal', function () {
    $('.modal'+ mainModalClass + ' .js-modal-body').html('');
  });

  // получаем, какую кнопку в аякс форме нажали
  $(document).on('mousedown', 'form.js-form-submit button', function(){
    let form = $(this).parents('form');
    if(form.length && $(this).attr('value')){
      form.find('.js-button-submit-value').val($(this).attr('value'));
    }
  });
});

